import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_TBS_CUSTOM_Schema } from './M_TBS_CUSTOM_Schema';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';

/** 교육 동영상 조회 SP_TRA_CUSTOM_04_R4 */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_TBS_CUSTOM_Schema.mapper.search1,
      context
    );
    return apiRequest(
      'post',
      Global.urls.ToolBoxMeeting.getTraCustom04R4,
      payload
    );
  }, successOptions);
};

/** 교육 파일 조회 SP_TRA_CUSTOM_04_R2 */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_TBS_CUSTOM_Schema.mapper.search2,
      context
    );
    return apiRequest(
      'post',
      Global.urls.ToolBoxMeeting.getTraCustom04R2,
      payload
    );
  }, successOptions);
};

/** 작업계획서 조회 SP_SAF_BASIC_01_R1 */
export const useSearch3 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const today = new Date();
    const threeYearsAgo = new Date();
    threeYearsAgo.setFullYear(today.getFullYear() - 3);
    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    };
    const ctx = {
      ...context,
      startDate: formatDate(threeYearsAgo),
      endDate: formatDate(today),
    };
    const payload = mapParamsBySchema(M_TBS_CUSTOM_Schema.mapper.search3, ctx);
    return apiRequest(
      'post',
      Global.urls.ToolBoxMeeting.getSamBasic01R1,
      payload
    );
  }, successOptions);
};

/** 최근 TBM 조회 */
export const useSearch4 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_TBS_CUSTOM_Schema.mapper.search4,
      context
    );
    return apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR1, payload);
  }, successOptions);
};

/** 단계 마지막 교육 지점 조회 */
export const useSearch5 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_TBS_CUSTOM_Schema.mapper.search5,
      context
    );
    return apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR4, payload);
  }, successOptions);
};

/** TBM 참가자 조회 getTbmNewR2 */
export const useSearch6 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_TBS_CUSTOM_Schema.mapper.search6,
      context
    );
    return apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR2, payload);
  }, successOptions);
};

/** TBM 세션 1건 조회 getTbmNewR5 */
export const useSearch7 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_TBS_CUSTOM_Schema.mapper.search7,
      context
    );
    return apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR6, payload);
  }, successOptions);
};

/** content 마지막 교육 지점 조회 */
export const useSearch8 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_TBS_CUSTOM_Schema.mapper.search8,
      context
    );
    return apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR9, payload);
  }, successOptions);
};

/** TBM 정보 저장 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_TBS_CUSTOM_Schema.mapper.save1);
    return apiRequest(
      'post1',
      Global.urls.ToolBoxMeeting.saveTbmNewU1,
      payload
    );
  }, options);
};

/** TBM 참가자 저장 */
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_TBS_CUSTOM_Schema.mapper.save2);
    return apiRequest(
      'post1',
      Global.urls.ToolBoxMeeting.saveTbmNewU2,
      payload
    );
  }, options);
};
